// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__FUTke","rootSmall":"AddTileButton_rootSmall__35Eog"};